import type { JSX } from 'react';

import { useTrackedPlayers } from '../api/games.ts';
import { Balances } from '../components/Balances.tsx';
import { Charges } from '../components/Charges.tsx';
import { WagersNeedingAnswer } from '../components/WagersNeedingAnswer.tsx';
import { WorkItOff } from '../components/WorkItOff.tsx';
import { NavLink } from '../router.tsx';
import { Card } from '../ui/Card.tsx';
import { hintClass, linkClass } from '../ui/styles.ts';

/** Nothing is tracked yet, so nothing can ever be owed: say where to start. */
function FirstRun(): JSX.Element | null {
  const players = useTrackedPlayers();

  if (players.data === undefined || players.data.length > 0) {
    return null;
  }

  return (
    <Card title="Start here">
      <p className={hintClass}>
        Nothing is tracked yet. Add a chess.com or lichess account and a standing rule under{' '}
        <NavLink to="/setup" className={linkClass}>
          Setup
        </NavLink>
        , and every loss it matches starts costing you work-time.
      </p>
    </Card>
  );
}

/** The first screen: what is owed, and what to do about it. */
export function Owed(): JSX.Element {
  return (
    <>
      <Balances />
      <WorkItOff />
      <WagersNeedingAnswer />
      <FirstRun />
      <Charges
        title="Latest charges"
        limit={5}
        actions={
          <NavLink to="/history" className={`text-sm ${linkClass}`}>
            All charges
          </NavLink>
        }
      />
    </>
  );
}
